export default function Datasheet(props) {
  const { React } = props;
  let DatasheetObj = props.productData.DatasheetObj
    ? props.productData.DatasheetObj
    : {};
  return (
    <div className="datasheet_details_page">
      <div className="datasheet_div ">
        {Object.keys(props?.productData?.DatasheetObj).map((category, Idx) => {
          return (
            <>
              {category !== "catalog" &&
              category !== "countryID" &&
              Object.keys(props.productData.DatasheetObj) ? (
                <div className={"datasheet_content_wrapper"}>
                  <h4> {category} </h4>
                  {Object.keys(props.productData.DatasheetObj[category]).map(
                    (ProductDetails, Id) => {
                      return (
                        <>
                          {
                            <div className="datashet_content">
                              <p>{ProductDetails}:</p>
                              <span>
                                {props.productData.DatasheetObj[category][
                                  ProductDetails
                                ].split("||").map((txt) => (
                                  <>
                                    {txt}
                                    <br></br>
                                  </>
                                ))}
                              </span>
                            </div>
                          }
                        </>
                      );
                    }
                  )}
                </div>
              ) : (
                <></>
              )}
            </>
          );
        })}
      </div>
    </div>
  );
}
